import * as React from "react";

const NextArrowIcon: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="32" viewBox="0 0 36 32" fill="none">
            <path
                d="M13.2808 6.78125L14.7198 8.22025L7.93676 15.0002H32V17.0002H7.93676L14.7188 23.7812L13.2808 25.2192L4.78076 16.7192L4.09376 16.0002L4.78076 15.2812L13.2808 6.78125Z"
                fill="#00389D"
            />
        </svg>
    );
};

export default React.memo(NextArrowIcon);
